<template>
  <div class="detail">
    <div class="top">
      <div class="tag" v-if="isEnd">报名已结束</div>
      <div class="banner">
        <span @click="$router.push({ name: 'home' })">首页</span> /
        <span>比赛详情</span>
      </div>
      <div class="top_bottom">
        <div class="left">
          <p class="tit">{{ info.name }}</p>
          <p>{{ info.apply_type === 1 ? ' 个人赛' : ' 团体赛' }}</p>
        </div>
        <div class="right" :class="isEnd && isApply ? 'mr-60' : ''">
          <div class="contents">
            <p class="name">报名时间</p>
            <p class="time">
              <span v-if="info.start">{{ parseTime(info.start) }}</span> -
              <span v-if="info.end">{{ parseTime(info.end) }}</span>
            </p>
          </div>
          <div class="btn_all">
            <Button class="btn" v-if="!isStart" disabled>报名未开始</Button>
            <Button v-if="isStart && !isEnd && !isApply" @click="signUp(isApply)" class="btn" type="primary">{{ '立即报名' }}</Button>
            <Button v-if="isStart && isApply" @click="signUp(isApply)" class="btn" type="primary">{{ '报名结果查询' }}</Button>
            <Button
              type="primary"
              v-if="haveResult"
              @click="
                $router.push({
                  name: 'competition_result',
                  query: {
                    id: id,
                    name: info.name,
                    apply_type: info.apply_type
                  }
                })
              "
              >比赛结果查询</Button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <p class="tit">比赛介绍</p>
        <div class="des" v-html="info.introduce"></div>
      </div>
      <div class="right">
        <p class="tit">最新公告</p>
        <div class="list">
          <div class="info" v-for="(item, index) in noticeList" :key="index">
            <p class="contents">{{ item.content }}</p>
            <p class="date">{{ transformTimestamp(item.updated_at) }}</p>
          </div>
        </div>
      </div>
    </div>
    <EditorForm
      :visible.sync="visible"
      :type="info.apply_type"
      :list="edit_list"
      @ok="getDetail()"
      :max="info.max_people_number"
      :min="info.min_people_number"
    />
    <Modal v-model="resultShow" width="800" title="报名结果" :centered="true">
      <div class="flex-between">
        <p v-if="info.apply_type === 2" class="team_name">团队：{{ team_name }}</p>
        <Button type="primary" @click="revokeApplyModal()" v-if="approvalStatus === 1 && !isEnd">撤销报名</Button>
        <Button type="primary" @click="resetSiginUp()" v-if="approvalStatus === 2 && !isEnd">重新报名</Button>
      </div>
      <Table :columns="columns" :data="resultList" :height="400">
        <template slot="status" slot-scope="{ row }">
          {{ row.status === 0 ? '待审核' : row.status === 1 ? '审核通过' : '拒绝' }}
        </template>
        <template slot="verify" slot-scope="{ row }">
          {{ parseTime(row.check_time) }}
        </template>
      </Table>
      <template slot="footer">
        <Button type="primary" @click=";(resultShow = false), getDetail()">确定</Button>
      </template>
    </Modal>
    <Modal v-model="hintShow" width="600" title="撤销报名" cancelText="取消" :centered="true" @on-ok="revokeApply()" @on-cancel="hintShow = false">
      <p>确定要撤销当前比赛报名吗？</p>
    </Modal>
  </div>
</template>

<script>
import { Button, Modal, Table, Message } from 'view-design'
import { transformTimestamp, parseTime } from '@/utils/index'
import EditorForm from './EditorForm.vue'
export default {
  components: {
    Button,
    EditorForm,
    Modal,
    Table
  },
  data() {
    return {
      noticeList: [],
      resultList: [],
      edit_list: [],
      info: {},
      isApply: false,
      haveResult: false,
      hintShow: false,
      isStart: false,
      isEnd: false,
      visible: false,
      resultShow: false,
      approvalStatus: 1, // 1 全部报名未审核  2报名全部被拒绝 3报名全部通过  4报名存在通过或者拒绝
      team_name: '',
      id: undefined,
      columns: [
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '身份证',
          key: 'id_card'
        },
        {
          title: '审核结果',
          slot: 'status'
        },
        {
          title: '审核时间',
          slot: 'verify'
        }
      ]
    }
  },
  created() {
    this.getDetail()
    this.getNotice()
  },
  methods: {
    parseTime,
    transformTimestamp,
    revokeApplyModal() {
      this.hintShow = true
    },
    async revokeApply() {
      const params = {
        uriCode: 'API013',
        id: this.id
      }
      try {
        await this.$fetch(params)
        Message.success('报名已撤销')
      } finally {
        this.hintShow = false
        this.resultShow = false
        this.getDetail()
      }
    },
    // 重新报名
    resetSiginUp() {
      console.log(this.info, this.resultList)
      const new_time = this.resultList[this.resultList.length - 1].created_at
      const new_result_list = this.resultList.filter(item => new_time === item.created_at)
      this.edit_list = new_result_list.map(item => {
        return { id_card: item.id_card, name: item.name, team_name: item.team_name }
      })
      this.resultShow = false
      this.signUp(false)
    },
    //获取比赛详情
    async getDetail() {
      const userId = JSON.parse(localStorage.getItem('userInfo'))?.uid
      this.id = this.$route.query.id
      const params = {
        uriCode: 'API008',
        id: this.id,
        uid: userId
      }
      const res = await this.$fetch(params)
      this.info = res.detail
      this.haveResult = res.haveResult
      this.isApply = res.isApply
      this.isStart = this.info.start < Date.now() ? true : false
      this.isEnd = this.info.end < Date.now() ? true : false
    },
    //获取报名结果
    async getSignUp() {
      if (!localStorage.getItem('userInfo')) {
        this.$router.push({ name: 'login' })
        return
      }
      const userId = JSON.parse(localStorage.getItem('userInfo'))?.uid

      const id = this.$route.query.id
      const params = {
        uriCode: 'API010',
        id: id,
        uid: userId
      }
      try {
        const res = await this.$fetch(params)
        this.resultList = res.list || []
        this.team_name = this.resultList[0].team_name
        if (this.info.apply_type === 1) {
          const len = this.resultList.length
          this.approvalStatus =
            this.resultList[len - 1].status === 0 ? 1 : this.resultList[len - 1].status === 2 ? 2 : this.resultList[len - 1].status === 3 ? 3 : 5
        } else {
          //status 0 待审核  1审核通过 2拒绝
          const new_time = this.resultList[this.resultList.length - 1].created_at
          const len = this.resultList.filter(item => new_time === item.created_at).length
          console.log(
            this.resultList.filter(item => item.status === 0 && new_time === item.created_at),
            'new_time'
          )
          const flag1 = this.resultList.filter(item => item.status === 0 && new_time === item.created_at).length === len
          const flag2 = this.resultList.filter(item => item.status === 2 && new_time === item.created_at).length === len
          const flag3 = this.resultList.filter(item => item.status === 1 && new_time === item.created_at).length === len
          const flag4 = this.resultList.filter(item => item.status !== 0 && new_time === item.created_at).length > 0
          // 1 全部报名未审核  2报名全部被拒绝 3报名全部通过  4报名存在通过或者拒绝 5未知
          this.approvalStatus = flag1 ? 1 : flag2 ? 2 : flag3 ? 3 : flag4 ? 4 : 5
        }
      } finally {
        this.resultShow = true
      }
    },
    // 获取公告列表
    async getNotice() {
      const params = {
        uriCode: 'API007',
        pageIndex: 1,
        pageSize: 50
      }
      const res = await this.$fetch(params)
      this.noticeList = res.list
    },
    signUp(flag) {
      if (!localStorage.getItem('userInfo')) {
        this.$router.push({ name: 'login' })
        return
      }
      if (!flag) {
        this.visible = true
      } else {
        this.getSignUp()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.team_name {
  line-height: 30px;
  padding-left: 4px;
  margin-bottom: 10px;
}

/deep/.ivu-modal-body {
  max-height: 500px;
  overflow-y: auto;
}

.detail {
  width: 100%;
  box-sizing: border-box;
  background: #f0f3f7;
  height: calc(100vh - 50px);
  padding: 24px;

  .content {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-top: 24px;

    .left {
      width: 100%;
      min-width: 818px;
      background-color: #fff;
      border-radius: 10px;
    }

    .right {
      min-width: 550px;
      background-color: #fff;
      border-radius: 10px;
      margin-left: 24px;

      .list {
        height: calc(100vh - 305px);
        overflow-y: auto;
        padding: 0 32px;
      }

      .info {
        padding: 15px 0;
        border-bottom: 1px solid #e9e9e9ff;

        .contents {
          color: rgba(0, 0, 0, 0.65);
          line-height: 22px;
          font-size: 14px;
        }

        .date {
          color: rgba(0, 0, 0, 0.25);
          line-height: 22px;
          margin-top: 6px;
        }
      }
    }

    .tit {
      line-height: 56px;
      font-size: 16px;
      font-weight: 600;
      padding-left: 32px;
      border-bottom: 1px solid #e9e9e9ff;
    }

    .des {
      width: 100%;
      box-sizing: border-box;
      padding: 20px 32px;
      font-size: 14px;
      color: #000000a6;
      height: calc(100vh - 305px);
      overflow-y: auto;
      line-height: 22px;
    }
  }
}

.top {
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  padding: 16px 32px;

  .banner {
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    font-size: 14px;

    span {
      cursor: pointer;
    }
  }

  .top_bottom {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    position: relative;

    .tit {
      color: #1890ff;
      font-weight: 600;
      line-height: 24px;
      font-size: 20px;
      margin-bottom: 8px;
      margin-top: 20px;
    }

    .btn_all {
      margin-top: -16px;
      height: 89px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      .btn {
        margin-bottom: 10px;
      }
    }

    .right {
      min-width: 450px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;

      .contents {
        .name {
          color: #00000073;
          margin-bottom: 10px;
        }

        .time {
          color: #000000d9;
        }
      }
    }
  }
}

.flex-between {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: 10px;
}
.tag {
  position: absolute;
  right: 0;
  top: 0;
  background-color: #ffccc7;
  color: #ff4d4f;
  height: 30px;
  font-size: 12px;
  line-height: 30px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 0px;
  padding: 0 10px 0 15px;
}
.mr-60 {
  margin-right: 60px;
}
</style>
